import { Component, ElementRef, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import { interval, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-ecu-information',
  templateUrl: './ecu-information.component.html',
  styleUrls: ['./ecu-information.component.css']
})

export class EcuInformationComponent implements OnInit {
  parentSection: 'basic-info' | 'full-info';
  lst_Result: any = [];
  lst_Search: any = [];
  strDate: string;
  strTime: string;
  showCustom_Map: boolean = false;

  mdl_Search: FormGroup = this.formBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('Session')!)),

    strUnitID: new FormControl(),

  });
  mdl_Map: FormGroup = this.formBuilder.group({

    strAddress: new FormControl(''),

    fLon: new FormControl(''),

    fLat: new FormControl(''),

    strSource: new FormControl(''),

  })

  private destroy$ = new Subject<void>();

  constructor(

    private el: ElementRef,

    private _tooltip: NotificationService,

    private router: Router,

    public _otherService: OtherService,

    private route: ActivatedRoute,

    private formBuilder: FormBuilder,

    private gurdService: GurdServiceService,

  ) {

  }

  ngOnInit(): void {

    const id = this.route.parent?.parent?.snapshot?.params['id'];
    this.parentSection = this.route.snapshot.data?.parentSection;

    this.mdl_Search.patchValue({

      strUnitID: id,

    });

    if (this.parentSection == 'basic-info') {
      this.getBasicInfo();

      interval(15000).pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.getBasicInfo(false);
      })
    }

    else if (this.parentSection == 'full-info') {
      this.getFullInfo();

      interval(15000).pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.getFullInfo(false);
      })
    }

  }

  ngOnDestroy() {
    this.stopTimer();
  }

  stopTimer() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async getBasicInfo(showSpinner: boolean = true) {

    if (showSpinner) {
      this._otherService.Showspinner();
    }

    let res = JSON.parse((await axios.post(`OBD2_LastValues`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '1xxA4' } });

      return;

    }

    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this.lst_Result = res;
    this.lst_Search = res;
  }

  async getFullInfo(showSpinner: boolean = true) {

    if (showSpinner) {
      this._otherService.Showspinner();
    }

    let res = JSON.parse((await axios.post(`CAN_LastValues`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '1xxA4' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Result = res;

    this.lst_Search = res;

  }

  filter_list(val: any) {

    this.lst_Result = this.lst_Search.filter((el: any) => {

      return el?.strComment?.includes(val.value) ||

        el?.strPersianName?.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Result = this.lst_Search;

    }

  }

  openChart(item) {
    const titile = this.gurdService.encrypt(item.strComment ?? item.strPersianName);
    window.localStorage.setItem("Ecu_title", titile);

    const urlTree = this.router.createUrlTree([
      'can',
      this.mdl_Search.value.strUnitID,
      this.parentSection,
      'data-chart',
      item.iOBD2_Code ?? item?.iCAN_LatestState

    ]);

    const serializedUrl = this.router.serializeUrl(urlTree)
    window.open(serializedUrl, '_blank');


  }

  showMap(item) {
    if (!item.fLat || item.fLat == 0 || !item.fLon || item.fLon == 0) {
      this._tooltip.showError('مختصاتی یافت نشد!');
      return;
    }

    this.mdl_Map.patchValue({
      strAddress: '',
      fLon: item.fLon,
      fLat: item.fLat,
      strSource: ''
    })

    this.showCustom_Map = true;

  }

}
